import { createSelector } from "@reduxjs/toolkit";
import { CurrentDate } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getCurrentDate = createSelector(
  (state: RootState) => state.gop[NameSpace.Date],
  (state: CurrentDate) => state.data
);

export const getFetchingStatusCurrentDate = createSelector(
  (state: RootState) => state.gop[NameSpace.Date],
  (state: CurrentDate) => state.fetchingStatusDate
);
